
import React from 'react'
import { Helmet } from 'react-helmet'
import CONSTANTS from '../constants'


const priceCalculation = (forfait) => {
  let price = 0
  !!Object.values(forfait.SubFunctionList).length &&
    forfait.SubFunctionList[0].ForfaitList.forEach((forfaitItem, fikey) => {
      if (forfaitItem.isSelected) {
        price += forfaitItem.Items[0].Prix
      }
      forfaitItem.Operations && forfaitItem.Operations.forEach((operation, OpKey) => {
        if (operation.isSelected) {
          price += operation.Items[0].Prix
        }
      })
    })
  return (price > 0)
}
/**

    - @desc Function calculate the price of all selected services in the Redux Store
    - @param SelectedServices store Object
    - @return Bool : there is services with selected prices or not .

 */
export function isExistPrestationWithForfait(SelectedServices) {
  let isExistPrestationWithForfait = false
  SelectedServices.forEach((fforfait, ffkey) => {
    fforfait.forfaits != null && !!Object.values(fforfait.forfaits) &&
      Object.values(fforfait.forfaits).forEach((forfait, fkey) => {
        isExistPrestationWithForfait = priceCalculation(forfait)
      })
  })
  console.log(isExistPrestationWithForfait)
  return (isExistPrestationWithForfait)
}
/**

    - @desc Function calculate the price of a single specific in the Redux Store
    - @param SingleSelectedService  Object
    - @return Bool : there is services with selected prices or not .

 */
export function isThisPrestationHasForfait(SingleSelectedService) {
  let isThisPrestationHasForfait = false
  console.log(SingleSelectedService)
  if (SingleSelectedService.forfaits != null && !!Object.values(SingleSelectedService.forfaits)) {
    isThisPrestationHasForfait = SingleSelectedService.forfaits.some(forfait => priceCalculation(forfait))

  }
  console.log(isThisPrestationHasForfait)
  return (isThisPrestationHasForfait)
}

/**
 * Get page Slug ex: rendez-vous en ligne => rendez-voys-en-ligne
 *
 * @param {String} text - text to convert
  *
 * @return {String}  text - Converted string
 */

export function slugify(text) {
  text = text.toString().toUpperCase().trim()
  const sets = [
    { to: 'a', from: '[ÀÁÂÃÄÅÆĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶἀ]' },
    { to: 'c', from: '[ÇĆĈČ]' },
    { to: 'd', from: '[ÐĎĐÞ]' },
    { to: 'e', from: '[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆ]' },
    { to: 'g', from: '[ĜĞĢǴ]' },
    { to: 'h', from: '[ĤḦ]' },
    { to: 'i', from: '[ÌÍÎÏĨĪĮİỈỊ]' },
    { to: 'j', from: '[Ĵ]' },
    { to: 'ij', from: '[Ĳ]' },
    { to: 'k', from: '[Ķ]' },
    { to: 'l', from: '[ĹĻĽŁ]' },
    { to: 'm', from: '[Ḿ]' },
    { to: 'n', from: '[ÑŃŅŇ]' },
    { to: 'o', from: '[ÒÓÔÕÖØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠ]' },
    { to: 'oe', from: '[Œ]' },
    { to: 'p', from: '[ṕ]' },
    { to: 'r', from: '[ŔŖŘ]' },
    { to: 's', from: '[ßŚŜŞŠȘ]' },
    { to: 't', from: '[ŢŤ]' },
    { to: 'u', from: '[ÙÚÛÜŨŪŬŮŰŲỤỦỨỪỬỮỰƯ]' },
    { to: 'w', from: '[ẂŴẀẄ]' },
    { to: 'x', from: '[ẍ]' },
    { to: 'y', from: '[ÝŶŸỲỴỶỸ]' },
    { to: 'z', from: '[ŹŻŽ]' },
    { to: '-', from: '[·/_,:;\']' }
  ]

  sets.forEach(set => {
    text = text.replace(new RegExp(set.from, 'gi'), set.to)
  })

  return text
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^-a-zа-я\u0370-\u03ff\u1f00-\u1fff]+/g, '') // Remove all non-word chars
    .replace(/--+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text

}

/**
 * Change page title & description
 *
 * @param {String} title - Page title
 * @param {String} description - Page description
 *
 * @return {Component}  - Halmet component
 */

export function headTitleTag(title = '', description = '') {
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name='description' content={description} />
      </Helmet>
    </>
  )
}

/**
 * get the phone number formatted
 *
 * @param {String} oldValue - Raw Phone Number
 *
 * @return {String} newValue - Phone number Phormatted
 */


export function removeNumbers(oldValue) {
  var newValue = ''
  newValue = oldValue.replace(/[0-9]/g, '')
  return newValue
}

export function getNewPhoneFormatValue(oldValue) {
  var newValue = ''
  newValue = oldValue.replace(/[^0-9\s\.]/g, '')
  newValue = reformatPhoneValueAccordingPhoneMask(newValue, CONSTANTS.SITE_INFO.PHONEMASK)
  return newValue
}

function reformatPhoneValueAccordingPhoneMask(oldValue, phoneMask) {
  var reformatedValue = ''
  if (phoneMask && oldValue) {
    var j = 0
    for (var i = 0; i < oldValue.length && j < phoneMask.length; i++) {
      if (oldValue[i] !== ' ' && phoneMask[j] !== ' ') {
        reformatedValue += oldValue[i]
        j++
      } else if (oldValue[i] !== ' ' && phoneMask[j] === ' ') {
        reformatedValue += ' ' + oldValue[i]
        j += 2
      } else if (oldValue[i] === ' ' && phoneMask[j] === ' ') {
        reformatedValue += oldValue[i]
        j++
      }
    }
    if (phoneMask && reformatedValue.length > phoneMask.length) { reformatedValue = reformatedValue.substring(0, phoneMask.length) }
  } else if (!phoneMask) {
    reformatedValue = oldValue
  }
  return reformatedValue
}


/**
 * get the formatted adress without country, ex : paris, france => paris
 *
 * @param {String} adress - Raw Adress
 *
 * @return {String}  adress - Formatted string
 * 
 */

export function formattedAdress(adress) {
  var lengthAd = adress.split(',').length
  if (lengthAd > 1)
    return adress.split(',', [lengthAd - 1]).toString()

  return adress
}

const isCurrencyBeforePrice = !!Number(window.siteConfig.PoundPlacement);
export const priceFormat = (price) =>{
return isCurrencyBeforePrice
  ? `${CONSTANTS.LABELS.common_v2_currency}${price}`
  : `${price} ${CONSTANTS.LABELS.common_v2_currency}`;
}